import type { FormikValues } from "formik";
import type { ReactNode } from "react";

import { FormContext } from "./FormContext";

type ProviderProps<Values extends FormikValues> = {
  value: FormContext<Values>;
  children: ReactNode;
};

export const FormProvider = <Values extends FormikValues = Record<string, undefined>>({
  children,
  value,
}: ProviderProps<Values>) => <FormContext.Provider value={value}>{children}</FormContext.Provider>;
